import http from '@/shared/api/http'

export async function getAllBrands() {
  return (await http.get('brands')).data
}

export async function getBrandById(brandId) {
  return (await http.get(`brands/${brandId}`)).data
}

export async function createBrand(payload) {
  return (await http.post('brands/create', payload)).data
}

export async function updateBrand(brandId, payload) {
  return (await http.put(`brands/update/${brandId}`, payload)).data
}

export async function deleteBrand(brandId) {
  return (await http.delete(`brands/delete/${brandId}`)).data
}